import { IFrameNavButton } from "../atoms/IFrameNavButton";
import { useNotificationsAdapter } from "adapters/notifications";

const NotificationsButton = () => {
  const props = useNotificationsAdapter("button");
  return <IFrameNavButton {...props} />;
};

export { NotificationsButton };
